import { useEnumTranslation } from '@/hooks/useEnumTranslation';
import {
  requisitionDisplayStatus,
  requisitionDisplayStatusColor
} from '@/features/procurement/utils/requisition-display-status';
import {
  purchaseOrderDisplayStatus,
  purchaseOrderDisplayStatusColor
} from '@/features/procurement/utils/purchase-order-display-status';
import type { BadgeColor } from '../badge-colors';
import type { ProcurementRow } from './proposal-part.types';

/** The state a procurement proposal row shows: label and colour. */
export interface ProcurementRowStatus {
  readonly label: string;
  readonly color: BadgeColor;
}

/** Labels a row's state as lists and the detail do; none for a row stored without it. */
export function useProcurementRowStatus(
  kind: 'requisitions' | 'purchaseOrders'
): (row: ProcurementRow) => ProcurementRowStatus | null {
  const tRequisition = useEnumTranslation('requisitionDisplayStatus');
  const tPurchaseOrder = useEnumTranslation('purchaseOrderDisplayStatus');

  return row => {
    const { approvalStatus } = row;
    if (approvalStatus === null) return null;
    if (kind === 'requisitions') {
      const status = requisitionDisplayStatus({ ...row, approvalStatus });
      return { label: tRequisition(status), color: requisitionDisplayStatusColor(status) };
    }
    const status = purchaseOrderDisplayStatus({ ...row, approvalStatus });
    return { label: tPurchaseOrder(status), color: purchaseOrderDisplayStatusColor(status) };
  };
}
